import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";
import _ from 'lodash';
import i18n from "@/shared/i18n";
import moment from "moment";
import {SYSTEM_DATE_FORMAT} from "@/core/services/formatter.service";

export default class AccountingSearchModel extends BaseModel {
  object_type = null
  sale_no = null
  dateRange = {startDate: null, endDate: null};

  rules = {};

  attributeLabels = {
    object_type: i18n.t("Type"),
    sale_no: i18n.t("Sale No"),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();

    if (this.dateRange.startDate) {
      data.date_after = moment(this.dateRange.startDate).format(SYSTEM_DATE_FORMAT);
      data.date_before = moment(this.dateRange.endDate).format(SYSTEM_DATE_FORMAT);
    }

    delete data.dateRange;

    delete data.customer;
    return data;
  }

  getFilteredData() {
    let returnData = [];

    const data = this.toJSON();

    for (let attr in data) {
      if (data[attr]) {
        let label = this.attributeLabels[attr];
        let value = _.capitalize(data[attr]);

        let text = `${label}: ${value}`;
        returnData.push({text, attr});
      }
    }

    return returnData;
  }
}

defineTranslatableProperties(AccountingSearchModel);
